export default "__VITE_ASSET__D7fdbPe9__"